/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars,@typescript-eslint/no-use-before-define */

import { first } from 'rxjs/operators';
import { EVENTS } from '../../../../app/constants/events';
import { ADWORDS_API_VERSIONS } from '../../../../app/constants/adwords_api_versions';
import { ADWORDS_STRUCTURE_REPORTS } from '../../../../app/constants/adwords_structure_reports';
import { selectValidators } from '../../../../app/common/validators/store/validators.selectors';
import { ADWORDS_ADS_V10_DATE_RANGE_TYPES } from '../../../../app/constants/adwords_ads_v10_date_range_types';

xplenty.directive('adwordsSourceEditor', [
  '$timeout',
  '$rootScope',
  '$http',
  '$translate',
  '$filter',
  'ngrxStoreService',
  function ($timeout, $rootScope, $http, $translate, $filter, ngrxStoreService) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./adwords-source-editor.html'),

      replace: true,

      scope: false,

      link($scope) {
        $scope.hasComponentChanged = 0;
        $scope.reportTypes = [];
        $scope.reportDateRangeFieldTypes = [{ text: 'None', value: '' }];
        let adwordsData = null;
        $scope.apiVersions = ADWORDS_API_VERSIONS;
        $scope.dateRangeTypes = ADWORDS_ADS_V10_DATE_RANGE_TYPES;
        let lastReportTypeObject;

        $scope.onReportTypeDateRangeFieldChange = function (reportTypeDateRangeField, skipType = false) {
          $scope.component.report_date_range_field = reportTypeDateRangeField;

          if (skipType) {
            return;
          }

          if (reportTypeDateRangeField === '') {
            $scope.component.report_date_range_type = '';
          } else {
            $scope.component.report_date_range_type = 'LAST_7_DAYS';
          }
        };

        if (
          !$scope.component.report_date_range_field &&
          ($scope.component.report_date_range_min || $scope.component.report_date_range_max)
        ) {
          $scope.onReportTypeDateRangeFieldChange('Date');
        }

        if (!$scope.component.report_date_range_field && $scope.component.report_date_range_type) {
          $scope.onReportTypeDateRangeFieldChange('Date', true);
        }

        $scope.componentUpdated = function (component) {
          $scope.component.customer_ids = component.customer_ids;
        };

        $scope.$watch(
          'component',
          function () {
            $scope.hasComponentChanged += 1;
          },
          true,
        );

        $scope.onApiVersionChange = function (apiVersion) {
          $scope.component.api_version = apiVersion;
          checkCurrentApiVersion(apiVersion);
          getReportTypes(apiVersion);

          $scope.dateRangeTypes = ADWORDS_ADS_V10_DATE_RANGE_TYPES;

          $scope.isDateRangeDisabled = false;
        };

        $scope.onReportTypeChange = function (reportType) {
          if (reportType) {
            $scope.component.report_type = reportType;
            setReportDateRangeFieldTypes(reportType);
          }
          $scope.isDateRangeDisabled = false;
          getFields();
          lastReportTypeObject = _.find($scope.reportTypes, { value: $scope.component.report_type });
        };

        $scope.onDateRangeChange = function (dateRange) {
          $scope.component.report_date_range_type = dateRange;

          if (dateRange !== 'CUSTOM_DATE') {
            $scope.component.report_date_range_min = '';
            $scope.component.report_date_range_max = '';
          }
        };

        $scope.onCustomerIdsChange = function (customerIds) {
          $scope.component.customer_ids = customerIds;
        };

        ngrxStoreService
          .select(selectValidators)
          .pipe(first())
          .subscribe((validators) => {
            init(validators);
          });

        function init(validators) {
          initApiVersions($scope.apiVersions, validators);

          $scope.onApiVersionChange($scope.component.api_version);
        }

        function initApiVersions(apiVersions, validators) {
          markDeadApiVersions(apiVersions, validators);
          const currentVersion = _.find(apiVersions, { value: $scope.component.api_version });
          checkCurrentApiVersion(currentVersion);
        }

        function markDeadApiVersions(apiVersions, validators) {
          const adwordsValidationConstraint = validators['Xplenty::JobAuthoring::Components::AdwordsSourceComponent'];

          if (!adwordsValidationConstraint) {
            return;
          }

          const supportedApiVersions = adwordsValidationConstraint.api_version.InclusionValidator.in;
          _.each(apiVersions, function (apiVersion) {
            if (supportedApiVersions.indexOf(apiVersion.value) === -1) {
              apiVersion.dead = true;
            }
          });
        }

        function checkCurrentApiVersion(currentApiVersion) {
          if (!currentApiVersion) {
            $scope.apiErrorMessage = `Selected api version ${$scope.component.api_version} is not found.`;
            $scope.component.api_version = $scope.apiVersions[0].value;
          } else if (currentApiVersion.dead) {
            $translate('adwords-source-editor.form.errors.api_version', { api_version: currentApiVersion.text }).then(
              function (error) {
                $scope.apiErrorMessage = error;
              },
            );
          }
        }

        function setReportDateRangeFieldTypes(reportType) {
          $scope.reportDateRangeFieldTypes = [{ text: 'None', value: '' }];

          const reportTypeObject = $scope.reportTypes.find((item) => item.value === reportType) || {};

          Object.keys(reportTypeObject.fields).forEach((key) => {
            const field = reportTypeObject.fields[key];
            if (field.dateRangeField) {
              $scope.reportDateRangeFieldTypes.push({
                text: field.title,
                value: key,
              });
            }
          });

          if (
            $scope.component.report_date_range_field == null &&
            ($scope.component.report_date_range_type != null || $scope.component.report_date_range_min != null)
          ) {
            if ($scope.reportDateRangeFieldTypes.length > 1) {
              $scope.component.report_date_range_field = $scope.reportDateRangeFieldTypes[1].value;
            } else {
              $scope.component.report_date_range_type = '';
              $scope.component.report_date_range_min = '';
              $scope.component.report_date_range_max = '';
            }
          }
        }

        function getReportTypes(apiVersion) {
          const selectedApiObject = _.find($scope.apiVersions, { value: apiVersion });
          if (selectedApiObject) {
            if (selectedApiObject.dead) {
              $translate('adwords-source-editor.form.errors.api_version', { api_version: selectedApiObject.text }).then(
                function (error) {
                  $scope.apiErrorMessage = error;
                },
              );
            } else {
              $scope.apiErrorMessage = null;
            }

            $http
              .get(`${process.env.API_URL}/adwords/${selectedApiObject.value}.json`)
              .then(function successCallback(response) {
                adwordsData = response.data;
                const reportTypes = [];
                _.each(response.data, function (obj) {
                  reportTypes.push({
                    text: obj.title,
                    value: obj.name,
                    fields: obj.fields,
                  });
                });

                $scope.reportTypes = reportTypes;

                const currentReportType = _.find(reportTypes, { value: $scope.component.report_type });
                if (!currentReportType) {
                  if ($scope.component.report_type && lastReportTypeObject) {
                    $translate('adwords-source-editor.form.errors.report_type', {
                      report: lastReportTypeObject.text,
                    }).then(function (error) {
                      $scope.reportErrorMessage = error;
                    });
                  }
                  $scope.component.report_type = reportTypes[0].value;
                }

                setReportDateRangeFieldTypes($scope.component.report_type);
                $scope.onReportTypeChange();
              });
          }
        }

        function getFields() {
          const currentReportType = _.find(adwordsData, { name: $scope.component.report_type });

          if (currentReportType) {
            const availableFields = [];

            _.each(currentReportType.fields, function (field, fieldName) {
              availableFields.push({
                name: fieldName,
                alias: fieldName,
                data_type: field.type,
                category: 'Fields',
              });
            });
            $rootScope.$broadcast(EVENTS.SCHEMA_IMPORTER_SET_AVAILABLE_FIELDS, availableFields);
          }
        }
      },
    };
  },
]);
